import React from "react";
import { useApp } from "@/context/AppContext";
import { waChatLink } from "@/lib/whatsapp";
import { MessageCircle } from "lucide-react";

export const WhatsAppFloat = () => {
  const { t } = useApp();
  return (
    <a href={waChatLink(t.common.waGreeting)} target="_blank" rel="noreferrer" data-testid="whatsapp-float-btn"
      aria-label="WhatsApp"
      className="fixed bottom-5 end-5 z-[90] flex items-center gap-2 bg-[#25D366] hover:bg-[#1ebe5b] text-white rounded-full pl-4 pr-5 py-3 shadow-2xl transition-transform hover:scale-105">
      <MessageCircle size={22} />
      <span className="text-sm font-bold hidden sm:inline">{t.common.chatWhatsapp}</span>
    </a>
  );
};
